'use client'

import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'

export default function GlobalError({
  error,
  reset,
}: Readonly<{
  error: Error & { digest?: string }
  reset: () => void
}>) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    /* @@TODO: lang=defaultLocale */
    <html lang="en">
      <body>
        <div className="text-center">
          <h1 className="text-2xl font-semibold mb-4">Something went wrong</h1>
          {error.message && (
            <p className="text-sm text-gray-600 mb-6">{error.message}</p>
          )}
          <button
            type="button"
            onClick={() => reset()}
            className="h-14 rounded-md bg-orange-600 px-4 py-2 text-gray-600 hover:bg-orange-500 disabled:opacity-50"
          >
            Try Again
          </button>
        </div>
      </body>
    </html>
  )
}
